import { trackLink, trackImpression } from 'lib/analytics/fpti'

/**
 * Track unilateral recipient choice overpanel impression via FPTI analytics
 */
export function trackUnilateralRecipientChoiceImpression() {
  trackImpression()
}

/**
 * Track unilateral recipient choice cancel button click on overpanel via FPTI analytics
 */
export function trackUnilateralRecipientChoiceCancel() {
  trackLink('cancel', 'link', {})
}

/**
 * Track unilateral recipient choice primary submit button via FPTI analytics
 */
export function trackUnilateralRecipientChoiceSubmit() {
  trackLink('submit', 'link', {})
}
